import { useForm } from '@inertiajs/react';

export default function Register({ errors }: { errors?: Record<string, string> }) {
  const { data, setData, post, processing } = useForm({
    email: '',
    password: '',
    password_confirmation: '',
  });

  function submit(e: React.FormEvent) {
    e.preventDefault();
    post('/users');
  }

  return (
    <div style={{ maxWidth: '400px', margin: '100px auto' }}>
      <h1>Register</h1>
      <form onSubmit={submit}>
        <div style={{ marginBottom: '1rem' }}>
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            value={data.email}
            onChange={(e) => setData('email', e.target.value)}
            style={{ width: '100%' }}
          />
          {errors?.email && <div style={{ color: 'red' }}>{errors.email}</div>}
        </div>
        <div style={{ marginBottom: '1rem' }}>
          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            value={data.password}
            onChange={(e) => setData('password', e.target.value)}
            style={{ width: '100%' }}
          />
          {errors?.password && <div style={{ color: 'red' }}>{errors.password}</div>}
        </div>
        <div style={{ marginBottom: '1rem' }}>
          <label htmlFor="password_confirmation">Password Confirmation</label>
          <input
            id="password_confirmation"
            type="password"
            value={data.password_confirmation}
            onChange={(e) => setData('password_confirmation', e.target.value)}
            style={{ width: '100%' }}
          />
        </div>
        <button type="submit" disabled={processing} style={{ padding: '0.5rem 1rem' }}>
          Register
        </button>
      </form>
    </div>
  );
}
